import { useMutation } from "@tanstack/react-query";
import { useTRPC } from "../../../shared/api/trpc";

export type ReorderTreeInput = {
  items: Array<{ id: string; kind: "board" | "folder" }>;
  parentFolderId?: string | null;
  spaceId: string;
};

export function useTreeReorder() {
  const trpc = useTRPC();
  const reorderMutation = useMutation(trpc.tree.reorder.mutationOptions());

  async function reorderTree(input: ReorderTreeInput) {
    await reorderMutation.mutateAsync(input);
  }

  return { reorderTree };
}
